import { UrlConstants } from "../url.constants";
export class ApiOrganisationSettingsConstants {
    static URL = UrlConstants.API_V2 + "OrganisationSettings";
}
